import { render, staticRenderFns } from "./ReservationCardDashboard.vue?vue&type=template&id=107d2877&"
import script from "./ReservationCardDashboard.vue?vue&type=script&lang=js&"
export * from "./ReservationCardDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ReservationCardDashboard.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports